<template>
    <aside :class="['sidebar', {'has-brand': showSidebarBrand}]">
        <div v-if="showSidebarBrand" class="sidebar-brand">
            <img class="brand-logo" :src="brandLogo"/>
        </div>
        <ul class="sidebar-list">
            <!-- 多级菜单 -->
            <li
                v-for="(item, index) in menuList" :key="index"
                class="item"
            >
                <div v-if="!item.notShow">
                    <div
                        v-if="item.list"
                        class="fisrt-level"
                        pointer
                        @mouseenter="tabHover(index)"
                        @mouseleave="() => isHover = false"
                    >
                        <!-- 多级菜单-第一级 -->
                        <div
                            class="category"
                            :class="{'category-active': index === current}"
                            @click="onCategoryClick(index)"
                        >
                            <div class="category-content-main">
                                <img
                                    class="icon"
                                    :class="{
                                        'icon-agent': item.name === '律师智能体',
                                    }"
                                    :src="index !== current ? item.avatar : item.activeAvatar || item.avatar"
                                />
                                <div class="name">{{ item.name }}</div>
                            </div>
                            <img
                                class="icon-arrow"
                                src="https://lvlin-fe-saas.bj.bcebos.com/sidebar/zhedie-arrow.svg"
                                :class="{
                                    'rotate-z-180deg': item.isFold,
                                }"
                            />
                        </div>
                        <!-- 多级菜单-第二级 -->
                        <ul
                            class="sub"
                            :style="{
                                'max-height': item.isFold
                                    ? 0
                                    : `${48 * item.list.length}px`,
                            }"
                        >
                            <router-link
                                v-for="(subitem, idx) in item.list"
                                :key="'subitem' + idx"
                                :to="{
                                    name: subitem.routerName,
                                    query: routers,
                                }"
                                tag="li"
                                pointer
                                :class="{
                                    'notice-remind':
                                        subitem.routerName === 'notice' &&
                                        announcementStatus,
                                }"
                                data-stat-track
                            >
                                <div
                                    class="law-tools"
                                    :class="{
                                        'active-tool': isRouteActive(subitem.routerName),
                                        'sub-hover': isHover && idx === subCurrent
                                            && index === hoverCurrent && !isRouteActive(subitem.routerName),
                                    }"
                                    @click="clickNav(subitem)"
                                    @mouseenter="subHover(idx)"
                                    @mouseleave="() => isHover = false"
                                >
                                    <div class="name">{{ subitem.name }}</div>
                                    <!-- <div
                                        v-if="subitem.badgeText"
                                        class="tool-icon"
                                    >
                                        {{ subitem.badgeText }}
                                    </div> -->
                                    <img
                                        v-if="subitem.badgeIcon"
                                        :src="subitem.badgeIcon"
                                        class="sub-tool-icon"
                                    >
                                    <!-- <div
                                        v-else-if="bkStatus && subitem.name === '我的百科'"
                                        class="tool-icon"
                                    >
                                        {{ bkStatus }}
                                    </div> -->
                                    <!-- <div
                                        v-if="unreadInfo[subitem.routerName]"
                                        class="unread-num"
                                    >
                                        {{ numebrHanlder(unreadInfo[subitem.routerName], 99) }}
                                    </div> -->
                                </div>
                            </router-link>
                        </ul>
                    </div>
                    <!-- 单级菜单 -->
                    <div
                        v-else
                        class="fisrt-level simple-level"
                        :class="{
                            'fisrt-level-hover': isHover && index === hoverCurrent
                                && !isRouteActive(item.routerName),
                        }"
                        @mouseenter="tabHover(index)"
                        @mouseleave="() => isHover = false"
                    >
                        <router-link
                            :to="{
                                name: item.routerName,
                                query: routers,
                            }"
                            pointer
                            tag="div"
                            :class="{
                                'notice-remind':
                                    item.routerName === 'notice' && announcementStatus,
                            }"
                            data-stat-track
                        >
                            <div
                                class="law-tools"
                                :class="{'active-tool': isRouteActive(item.routerName)}"
                                @click="clickNav(item)"
                            >
                                <img
                                    class="icon"
                                    :src="isRouteActive(item.routerName)
                                        ? item.activeAvatar || item.avatar
                                        : item.avatar"
                                />
                                <div
                                    class="name"
                                >
                                    {{ item.name }}
                                </div>
                                <div
                                    v-if="item.badgeText"
                                    class="tool-icon first-level"
                                >
                                    {{ item.badgeText }}
                                </div>
                                <div
                                    v-if="unreadInfo[item.routerName]"
                                    class="unread-num"
                                >
                                    {{ numebrHanlder(unreadInfo[item.routerName], 99) }}
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </li>
        </ul>
    </aside>
</template>
<script>
/**
 * @file Sidebar 边栏，树形菜单
 * @author YongZhang<zhangyong06@baidu.com>
 * @date 2019-10-08
 */
import {mapState, mapMutations, mapActions} from 'vuex';
import eventBus from '@/mixins/eventBus';
import {getTabNews} from '../utils/commonReq';
export default {
    mixins: [eventBus(['consult_unread_num', 'case_modify', 'bk_status_change'])],
    data() {
        return {
            theme2: 'light',
            routers: {},
            timer: null,
            newsTimer: null,
            // 课程上一次更新的时间戳
            courseUpdateTimer: '',
            current: -1,
            isHover: false,
            hoverCurrent: 0,
            subCurrent: 0,
            // 菜单--未读数信息 key 菜单路由
            unreadInfo: {
                // 1v1咨询
                consult: 0,
                // 案例管理
                caseManage: 0,
                // 华律1v1咨询
                platformConsult1v1: 0
            },
            bkStatus: ''
        };
    },
    components: {
    },
    computed: {
        ...mapState({
            menuList: state => state.Menu.menuList,
            announcementStatus: state => state.Menu.hasUnReadAnnouncement,
            userInfoNew: state => state.lawStore?.userInfoNew || {},
            latestId: state => state.Service.aiContract.latestId,
            ind: state => state.Industry.ind
        }),
        showSidebarBrand() {
            return true;
        },
        brandLogo() {
            return this.ind?.law?.logo || '';
        }
    },
    created() {
        this.getBkInfo();
        this.getContentNum();
    },
    watch: {
        userInfoNew(val) {
            // 律师角色
            if (+val?.user_role === 0) {
                this.getUnreadNum();
                this.repeatGetUnreadNum(0);

                // 智能合同轮询
                this.getLatestContract();
                this.getCurrentContract();

                this.getCommonUnreadNum();
                this.repeatGetTabNews();
            }

            // 代理商和律所
            if (+val?.user_role === 1 || +val?.user_role === 2) {
                this.getPlatformUnreadNum();
                this.repeatGetUnreadNum(1);
            }
        },
        '$route': {
            handler(val) {
                // 控制sidebar图标切换
                let path = val.path.slice(1);
                for (let i = 0; i < this.menuList.length; i++) {
                    if (this.menuList[i].routerName === path) {
                        this.current = i;
                        break;
                    }
                    if (this.menuList[i].list) {
                        for (let j = 0; j < this.menuList[i].list.length; j++) {
                            if (this.menuList[i].list[j].routerName === path) {
                                this.current = i;
                                return;
                            }
                        }
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapMutations({
            setBadgeTextValue: 'Menu/setBadgeTextValue'
        }),
        ...mapActions({
            getLatestContract: 'Service/getLatestContract',
            getCurrentContract: 'Service/getCurrentContract'
        }),
        getRequest(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const req = window.location.search.substr(1).match(reg);
            if (req !== null) {
                return decodeURIComponent(req[2]);
            }
            return null;
        },
        isRouteActive(routerName) {
            const routeName = this.$route?.name;
            const routePath = this.$route?.path?.slice(1);
            return routerName === routeName || routerName === routePath;
        },
        onCategoryClick(index) {
            this.$store.dispatch('Menu/togglePluginFoldStatus', index);
        },
        clickNav(data) {
            this.$wywLog.send({
                serverId: 16814,
                page: data.routerName || 'law',
                action: 'click',
                area: 'nav',
                uk: this.userInfoNew?.uk || '',
                fr: this.$route?.query?.fr || ''
            });
            if (data.name === '课程中心') {
                this.setBadgeTextValue({
                    routeName: '课程中心',
                    value: ''
                });
                localStorage.setItem(
                    'courseUpdateTimer',
                    this.courseUpdateTimer
                );
            }
        },
        // 请求1v1 咨询待跟进咨询数
        getUnreadNum() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/bp/consult/getunfollowcnt')
                    .then(res => {
                        if (!res || +res.code !== 0 || !res.data) {
                            reject();
                            return;
                        }
                        resolve();
                        this.unreadInfo.consult = res?.data?.unfollow_cnt || 0;
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
        // 请求华律端 1v1 待沟通咨询数
        getPlatformUnreadNum() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/bp/platform/consult/list')
                    .then(res => {
                        if (!res || +res.code !== 0 || !res.data) {
                            reject();
                            return;
                        }
                        resolve();
                        this.unreadInfo.platformConsult1v1 = res?.data?.statistics_data.pending_com_cnt || 0;
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
        // 案例修改后更新案例驳回数量
        on_case_modify() {
            this.getCommonUnreadNum();
        },
        /**
         * 轮训再上一个请求结果返回后 10min 后请求接口
         */
        repeatGetUnreadNum(userRole) {
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                (userRole === 0 ? this.getUnreadNum() : this.getPlatformUnreadNum())
                    .then(() => {
                        // 接口请求成功继续下一次请求
                        this.repeatGetUnreadNum();
                    })
                    .catch(() => {
                        // 接口请求失败则不再继续轮训
                        this.timer = null;
                        clearTimeout(this.timer);
                    });
            }, 600000);
        },

        /**
         * 轮训再上一个请求结果返回后 10min 后请求接口
         */
        repeatGetTabNews() {
            this.newsTimer && clearTimeout(this.newsTimer);
            this.newsTimer = setTimeout(() => {
                getTabNews()
                    .then(data => {
                        this.courseUpdateTimer = data['课程中心'] || '';
                        // 接口请求成功继续下一次请求
                        this.repeatGetTabNews();
                    })
                    .catch(() => {
                        // 接口请求失败则不再继续轮训
                        this.newsTimer = null;
                        clearTimeout(this.newsTimer);
                    });
            }, 600000);
        },

        /**
         * 公共的请求未读数的方法
         */
        getCommonUnreadNum() {
            getTabNews().then(data => {
                const {info} = data || {};
                this.courseUpdateTimer = info['课程中心'] || '';
                // 上一次课程更新时间戳
                let courseUpdateTimer
                    = localStorage.getItem('courseUpdateTimer');
                if (
                    !courseUpdateTimer
                    || this.courseUpdateTimer > courseUpdateTimer
                ) {
                    this.setBadgeTextValue({
                        routeName: '课程中心',
                        value: ''
                    });
                }
                else if (this.courseUpdateTimer === courseUpdateTimer) {
                    this.setBadgeTextValue({
                        routeName: '课程中心',
                        value: ''
                    });
                }
            });
        },
        tabHover(index) {
            this.hoverCurrent = index;
            this.isHover = true;
        },
        subHover(index) {
            this.subCurrent = index;
            this.isHover = true;
        },

        /**
         * 数字处理
         */
        numebrHanlder(num, max) {
            if (!max) {
                return num || 0;
            }
            if (!num) {
                return 0;
            }
            return num > max ? `${max}+` : num;
        },
        getBkInfo() {
            this.$http
                .get('/bp/api/baike/info')
                .then(res => {
                    if (+res?.code === 0) {
                        // 0 未加入(未关联)， 1 待审核(审核中)， 2 百科词条&繁星已加入(已关联)， 3 百科词条加入&繁星计划未加入(已关联)
                        let bkMap = {
                            0: '未关联',
                            1: '审核中',
                            2: '已关联',
                            3: '已关联'
                        };
                        let status = res?.data?.status || 0;
                        this.bkStatus = bkMap[status] || '';
                    }
                })
                .catch(err => {});
        },
        on_bk_status_change() {
            this.getBkInfo();
        },
        getContentNum() {
            this.$http.get('/bp/api/content/mycontentnum').then(res => {
                if (res?.code !== '0' || !res?.data) {
                    return;
                }
                const {fast_claim_auth} = res.data || {};
                if (fast_claim_auth === 1) {
                    this.setBadgeTextValue({
                        routeName: '热搜问答',
                        value: ''
                    });
                }
            }).catch(err => {});
        }
    }
};
</script>
<style lang="less" scoped>
.sidebar {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    color: #1e1f24;
    border-right: 1px solid #eee;
    user-select: none;
    z-index: 1;
    overflow: hidden;

    .sidebar-brand {
        display: flex;
        align-items: center;
        padding: 20px 18px 20px 15px;
        flex-shrink: 0;
    }

    .brand-logo {
        display: block;
        width: 132px;
        height: 20px;
    }

    .sidebar-list {
        flex: 1;
        min-height: 0;
        margin: 0;
        padding: 10px 6px 24px;
        list-style: none;
        overflow-y: scroll;
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
        }
    }

    .item {
        margin-left: 0 !important;
    }

    .name {
        font-family: "PingFang SC";
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
    }

    .simple-level {
        height: 44px;

        .law-tools {
            padding-inline: 8px;

            .name {
                font-size: 16px;
                font-weight: 500;
            }
        }
    }

    .fisrt-level-hover {
        background: #f7f8fa;
        border-radius: 8px;
    }

    .category {
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 18px 8px 12px;

        .category-content-main {
            display: flex;
            align-items: center;

            .name {
                font-size: 16px;
                line-height: 16px;
                font-weight: 500;
            }
        }

        &.category-active .category-content-main .name {
            color: #0054ff;
        }
    }

    .icon {
        width: 16px;
        height: 16px;
        margin-right: 6px !important;
    }

    .icon-arrow {
        width: 16px;
        height: 16px;
        transition: transform .2s ease-out;

        &.rotate-z-180deg {
            transform: rotateZ(180deg);
        }
    }

    .icon-agent {
        height: 18px;
        transform: translateY(-1px);
    }

    .sub {
        padding-inline: 0 !important;
        color: #1e1f24;
        overflow: hidden;
        transition: max-height .2s ease-out;
        -webkit-transition: max-height .2s ease-out;

        // 子菜单最后一项去掉底部间距
        & > li:last-child .law-tools {
            margin-bottom: 0;
        }
    }

    .notice-remind {
        position: relative;

        &::after {
            content: "";
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: red;
            position: absolute;
            top: 50%;
            margin-top: -3.5px;
            right: 62px;
        }
    }

    .law-tools {
        height: 44px;
        display: flex;
        align-items: center;
        font-weight: 400;
        padding-left: 30px;
        padding-right: 8px;
        border-radius: 8px;
        margin-bottom: 4px;

        .name {
            color: #50525c;
        }

        &.active-tool {
            background: linear-gradient(271.66deg, rgba(0, 84, 255, .05) -.59%, rgba(0, 143, 255, .05) 100%);

            .name {
                color: #0054ff;
            }
        }

        &.sub-hover,
        &:not(.active-tool):hover {
            background: #f7f8fa;
        }

        .tool-icon {
            height: 18px;
            margin-left: 6px;
            color: #fff;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            padding: 0 5.5px;
            width: max-content;
            line-height: 18px;
            border-radius: 9px;
            background: #ff274b;
            box-shadow: 0 3px 10px 0 rgba(255, 39, 75, .3);
        }

        .sub-tool-icon {
            width: 30px;
            height: 10px;
            object-fit: contain;
            margin-left: auto;
        }

        .unread-num {
            margin-left: 6px;
            height: 18px;
            padding: 0 7px;
            line-height: 18px;
            color: #fff;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            border-radius: 12px;
            background: #ff274b;
            box-shadow: 0 3px 10px 0 rgba(255, 39, 75, .3);
        }
    }
}
</style>
